import React, { PureComponent } from "react";

import Select from "react-select";

import moment from "moment";

import { Popover, OverlayTrigger, Modal } from "react-bootstrap";
import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import { isEnabled } from "utils/featureFlags";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import ModelError from "components/Results/ModelError";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import BusinessHeaderContainer from "containers/Business/BusinessHeader";
import SubgroupMenuContainer from "containers/Business/SubgroupMenu/SubgroupMenu";

import SelectDataWrapperContainer from "containers/UnifiedProject/SelectData/SelectDataWrapper";

import RealityCheckContainer from "containers/Business/RealityCheck/RealityCheck";
import OptimizeContainer from "containers/Business/Optimize/Optimize";
import OptimizationContainer from "containers/Business/Optimization/Optimization";
import StrategyContainer from "containers/Business/Strategy/Strategy";
import TestPredictionsContainer from "containers/Business/TestPredictions/TestPredictions";
import DeployContainer from "containers/Business/Deploy/Deploy";
import ModelListContainer from "containers/Business/ModelList/ModelList";
import IntegrateContainer from "containers/UnifiedProject/Integrate/Integrate";
import TrainContainer from "containers/Business/Train/Train";
import MonitoringContainer from "containers/Monitoring/Monitoring";
import AuditContainer from "containers/Business/Audit/Audit";
import ForecastContainer from "containers/UnifiedProject/Forecast/Forecast";

import CompareScenario from "components/Project/CompareScenario";

import * as wizardReducer from "containers/Wizard/reducer";

import { UNIFIED_PROJECT_STEPS } from "containers/Business/BusinessReducer";

import styles from "./style.module.css";

export default class Business extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isCompare: false,
      showSubgroups: false,
      highlightStep: undefined,
      userFilter: "All",
      typeFilter: "All",
      scenarioName: props.userName ? props.userName + "'s Scenario" : "New Scenario"
    };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderStep() {
    const { isEditBlueprint, currentStep, optimized, id, rerunSegment, isError } = this.props;

    const isOverallSegment = this.getIsOverallSegment();

    if (isError) {
      switch (currentStep) {
        case UNIFIED_PROJECT_STEPS.SELECT_DATA.id:
        default:
          return (
            <div className={styles.loading}>
              <ModelError errors={optimized.errors} />
              <div className={styles.retrain}>
                <Button onClick={() => rerunSegment(optimized.segmentId)}>{"Retrain Frontier"}</Button>
              </div>
            </div>
          );
      }
    }

    switch (currentStep) {
      case UNIFIED_PROJECT_STEPS.SELECT_DATA.id:
        return (
          // PULLING FROM UNIFIED PROJECT NOW
          <SelectDataWrapperContainer
            {...this.props}
            runId={id === "new" ? (isEditBlueprint ? "editBlueprint" : id) : optimized && optimized.innerId}
            type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
            hasProject={optimized !== undefined}
            businessMode
          />
        );
      case UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id:
        return <OptimizationContainer {...this.props} />;
      case UNIFIED_PROJECT_STEPS.BUSINESS_STRATEGY.id:
        return <StrategyContainer {...this.props} />;
      case UNIFIED_PROJECT_STEPS.AI_MODEL.id:
        return <ModelListContainer {...this.props} projectId={id} />;
      /*
      case UNIFIED_PROJECT_STEPS.AI_MODEL.id:
        return (
          <TrainContainer
            {...this.props}
            id={
              optimized && optimized.innerId !== undefined
                ? optimized.innerId
                : "new"
            }
            projectId={id}
          />
        );
      */
      case UNIFIED_PROJECT_STEPS.FORECAST.id:
        return (
          <ForecastContainer
            {...this.props}
            id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
            projectId={id}
          />
        );
      case UNIFIED_PROJECT_STEPS.INTEGRATE.id:
        return <IntegrateContainer {...this.props} businessMode />;
      case UNIFIED_PROJECT_STEPS.MONITOR.id:
        return <MonitoringContainer id={id} />;
      default:
        return (
          <div style={{ height: "200vh", background: "white" }}>
            <div>{currentStep}</div>
          </div>
        );
    }
  }

  renderFooter() {
    const {
      hasSplits,
      allScenarios,
      isEditBlueprint,
      project,
      optimized,
      modelGroups,
      viewScenario,
      isOnlyFooter,
      isConsumer,
      deleteScenario,
      shortlistScenario,
      compareScenarioIndex,
      updateCompareScenarioIndex,
      updateShowPending,
      updateShowShortListed,
      selectedScenario,
      approvedScenario,
      removeShortlist,
      saveScenario,
      isAFO,
      currentStep,
      deploy,
      refresh,
      aibleViewType,
      isNextEnabled,
      updateCurrentStep,
      trainAI,
      setup,
      isSavingBlueprint,
      showPending,
      showShortListed,
      viewingScenarioIndex,
      viewAllScenarios,
      saveBlueprint,
      updateIsEditBlueprint,
      canEditSegments,
      label,
      blueprint,
      updateLabel,
      hasLoadedAllJobs,
      hasSetupIgnoreChanged,
      isRetraining,
      retrainRun,
      userName,
      isForecast,
      forecastTimeCol,
      forecastMode
    } = this.props;
    const {
      isCompare,
      isExplain,
      isDeploy,
      isDeployScreen,
      isAdvancedDeploy,
      isCreatingScenario,
      isDeletingScenario,
      isDeployingProject,
      userFilter,
      typeFilter,
      scenarioName,
      isCreatingProject
    } = this.state;

    let hasSameScenario = false;

    const userOptions =
      project && project.roles
        ? project.roles.map((r) => ({
            label: r.role_user.fullname,
            value: r.role_user.id
          }))
        : [];

    const sOptions = [{ label: "All Users", value: "All" }].concat(userOptions);

    const typeOptions = [
      { label: "All Scenarios", value: "All" },
      { label: "Shortlisted", value: "Shortlisted" },
      { label: "Pending", value: "Pending" }
    ];

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    const isOnlyOverall = project && project.segments && project.segments.length <= 1 ? true : false;

    const isSelectedApproved = selectedScenario?.isApproved;

    const sameSetup = approvedScenario && optimized && isSameSetup(approvedScenario.data, optimized.setup);

    const showTabs = hasSplits && (currentStep !== UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id || isContinuous);

    return (
      <div
        className={
          styles.footerHolder +
          " " +
          (showTabs
            ? this.state.showSubgroups
              ? styles.largeLeftMargin
              : styles.leftMargin
            : styles.footerHolderNoSplits)
        }
        style={isOnlyFooter ? { marginLeft: "0px", width: "100%" } : {}}
      >
        {isEditBlueprint ? (
          isSavingBlueprint ? (
            <div className={styles.fastButtons}>
              <LoadingIndicator style={{ margin: "0px", marginRight: "10px" }} />
            </div>
          ) : (
            <div className={styles.fastButtons}>
              <Button onClick={() => updateIsEditBlueprint(false)}>{"Cancel"}</Button>
              <div style={{ flexGrow: 1 }} />
              <div className={styles.blueprintName}>
                <span>{"Blueprint Name: "}</span>
                <LineInput
                  isShowEditable
                  isEditable
                  showRight
                  defaultValue={
                    blueprint && blueprint.name ? blueprint.name : setup && setup.label ? setup.label : "New Blueprint"
                  }
                  value={setup && setup.label ? setup.label : blueprint && blueprint.name ? blueprint.name : undefined}
                  onChange={(val) => updateLabel(val)}
                  style={{
                    width: "200px",
                    margin: "0px 20px 0px 10px"
                  }}
                />
              </div>
              {blueprint ? (
                <Button style={{ marginLeft: "20px" }} onClick={() => saveBlueprint()}>
                  {"Save as New Blueprint"}
                </Button>
              ) : (
                ""
              )}
              <Button
                style={{ marginLeft: "20px" }}
                disabled={this.getIsOverallSegment() || isOnlyFooter}
                onClick={() => saveBlueprint(true)}
              >
                {"Save and Apply Blueprint"}
              </Button>
            </div>
          )
        ) : project === undefined ? (
          <div className={styles.newFooter}>
            {isCreatingProject ? (
              <LoadingIndicator
                style={{
                  margin: "0px",
                  display: "flex",
                  justifyContent: "center",
                  width: "250px",
                  transform: "scale(0.75)"
                }}
              />
            ) : currentStep === UNIFIED_PROJECT_STEPS.SELECT_DATA.id ? (
              <OverlayTrigger
                placement="left"
                trigger={isNextEnabled ? [] : ["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-left">
                    <div>{"Select an outcome to predict to proceed"}</div>
                  </Popover>
                }
              >
                <Button
                  disabled={!isNextEnabled || isOnlyFooter || (isForecast && !forecastTimeCol)}
                  onClick={() => {
                    this.setState({ isCreatingProject: true });
                    trainAI({
                      retStep: UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id,
                      isFastTrain: true,
                      source: "business"
                    });
                  }}
                  type={"primary"}
                  style={{ marginRight: "5px" }}
                >
                  {isForecast ? "Train AI" : "Create AI"}
                </Button>
              </OverlayTrigger>
            ) : (
              <div />
            )}
            {/* {isCreatingProject ? (
              <div />
            ) : currentStep === UNIFIED_PROJECT_STEPS.SELECT_DATA.id ? (
              <Button
                type="primary"
                disabled={!isNextEnabled}
                onClick={() =>
                  updateCurrentStep(
                    UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id
                  )
                }
                style={{ marginLeft: "5px" }}
              >
                {"Add Business Assumptions"}
              </Button>
            ) : currentStep ===
              UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id ? (
              <Button
                type="primary"
                disabled={!isNextEnabled}
                onClick={() => {
                  this.setState({ isCreatingProject: true });
                  trainAI();
                }}
                style={{ marginLeft: "5px" }}
              >
                {"Train AI"}
              </Button>
            ) : currentStep === UNIFIED_PROJECT_STEPS.SELECT_DATA.id ? (
              <Button
                type="primary"
                disabled={!isNextEnabled}
                onClick={() =>
                  updateCurrentStep(
                    UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id
                  )
                }
                style={{ marginLeft: "5px" }}
              >
                {"Add Expected Behavior"}
              </Button>
            ) : (
              <Button
                type="primary"
                disabled={!isNextEnabled}
                onClick={() =>
                  updateCurrentStep(
                    UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id
                  )
                }
                style={{ marginLeft: "5px" }}
              >
                {"Review Business Assumptions"}
              </Button>
            )} */}
          </div>
        ) : (
          <div className={styles.fSection}>
            {optimized && optimized.isLoading ? (
              <LoadingIndicator style={{ margin: "0px auto 0px 20px" }} />
            ) : setup &&
              setup.isFastTrain === true &&
              sameSetup === true &&
              allScenarios &&
              allScenarios.length === 0 &&
              !isConsumer ? (
              <Button
                disabled={!hasLoadedAllJobs || isCreatingScenario}
                title={!hasLoadedAllJobs ? "Waiting for all subgroups to report models" : undefined}
                onClick={() => {
                  this.setState({ isCreatingScenario: true });
                  return saveScenario("Default Scenario").then(() => this.setState({ isCreatingScenario: false }));
                }}
                style={{ marginLeft: "20px" }}
              >
                {"Create Default Scenario"}
              </Button>
            ) : (
              <React.Fragment>
                {sOptions.filter((s) => s.value === userFilter).length > 1 && (
                  <div className={styles.scenarioPicker}>
                    <Select
                      options={sOptions}
                      value={
                        sOptions.filter((s) => s.value === userFilter).length > 0
                          ? sOptions.filter((s) => s.value === userFilter)[0]
                          : { label: "All Users", value: "All" }
                      }
                      menuPlacement={"top"}
                      onChange={(val) => this.setState({ userFilter: val.value })}
                    />
                  </div>
                )}
                {isConsumer && (!allScenarios || (allScenarios && allScenarios.length === 0)) ? (
                  <div style={{ fontSize: 16 }}>{"No Scenarios Found"}</div>
                ) : allScenarios ? (
                  <ButtonGroup
                    style={{
                      maxWidth: "100%",
                      overflowX: "auto"
                    }}
                  >
                    {allScenarios
                      .sort((a, b) => a.index - b.index)
                      .filter((s) => s.scenario !== undefined)
                      .map((s, i) => {
                        let isSameScenario = true;
                        Object.keys(s.scenario)
                          .filter((c, i, sList) => sList.length === 1 || i > 0 || true)
                          .sort((a, b) => (a === "Overall" ? -1 : b === "Overall" ? 1 : a < b ? -1 : 1))
                          .forEach((k, i, sList) => {
                            if (modelGroups.drilldownValues[i] === undefined) {
                              isSameScenario = false;
                            } else if (
                              isSameSetup(s.scenario[k].setup.data, modelGroups.drilldownValues[i].oSetup) === false
                            ) {
                              isSameScenario = false;
                            }
                          });

                        if (isSameScenario === true && s && viewingScenarioIndex === s.index) {
                          hasSameScenario = true;
                        }

                        let shouldRender =
                          userFilter === "All" ||
                          (s.originalScenario &&
                            s.originalScenario.created_by &&
                            userFilter === s.originalScenario.created_by.id);

                        shouldRender =
                          shouldRender &&
                          (typeFilter === "Pending" && s.originalScenario.status === "PENDING" ? false : true);

                        shouldRender =
                          shouldRender &&
                          (typeFilter === "Shortlisted" && s.originalScenario.status === "DRAFT" ? false : true);

                        return !shouldRender ? (
                          <div key={i} />
                        ) : (
                          <OverlayTrigger
                            key={i}
                            placement="top"
                            trigger={["hover"]}
                            rootClose
                            overlay={
                              <Popover id="popover-positioned-top" title={s.originalScenario.name}>
                                <div className={styles.resoucePopup}>
                                  <div className={styles.tooltipLine}>
                                    <div className={styles.tBold}>{"Created By"}</div>
                                    <div>{s.originalScenario.created_by.fullname}</div>
                                  </div>
                                  <div className={styles.tooltipLine}>
                                    <div className={styles.tBold}>{"Created On"}</div>
                                    <div>
                                      {moment
                                        .utc(s.originalScenario.created_date)
                                        .local()
                                        .format("MMMM Do YYYY, h:mm:ss a")}
                                    </div>
                                  </div>
                                  <div className={styles.tooltipLine}>
                                    <div className={styles.tBold}>{"Status"}</div>
                                    <div>{s.originalScenario.status}</div>
                                  </div>
                                </div>
                              </Popover>
                            }
                          >
                            <Button
                              className={styles.footerBtn}
                              key={i}
                              onClick={
                                isCompare ? () => updateCompareScenarioIndex(i) : () => viewScenario(s.scenario, i)
                              }
                              onMouseOver={
                                isCompare && compareScenarioIndex !== i ? () => updateCompareScenarioIndex(i) : () => {}
                              }
                              active={
                                isCompare || (isSameScenario && s && viewingScenarioIndex !== s.index)
                                  ? false
                                  : (isSameScenario && s && viewingScenarioIndex === s.index) ||
                                    (isCompare && compareScenarioIndex === i)
                              }
                              style={
                                isCompare && viewingScenarioIndex === s.index
                                  ? { border: "2px solid rgb(239, 126, 84)" }
                                  : isCompare && compareScenarioIndex === s.index
                                    ? { border: "2px solid rgb(126, 105, 215)" }
                                    : (!isCompare && isSameScenario && s && viewingScenarioIndex !== s.index) ||
                                        (!isSameScenario && s && viewingScenarioIndex === s.index)
                                      ? { border: "2px solid rgb(126, 105, 215)" }
                                      : undefined
                              }
                            >
                              {s.originalScenario ? s.originalScenario.name : i}
                            </Button>
                          </OverlayTrigger>
                        );
                      })}
                    {/*<Button
                      disabled={hasSameScenario}
                      active={hasSameScenario === false}
                    >
                      {"New"}
                    </Button>*/}
                  </ButtonGroup>
                ) : (
                  <div />
                )}
                {hasSameScenario || isConsumer ? (
                  <div />
                ) : (
                  <div className={styles.nameInput}>
                    <LineInput
                      isMediumBox
                      value={scenarioName}
                      onChange={(val) => this.setState({ scenarioName: val })}
                    />
                  </div>
                )}
                <ButtonGroup>
                  {isConsumer ? (
                    <React.Fragment />
                  ) : (
                    <Button
                      disabled={!hasLoadedAllJobs || hasSameScenario || isCreatingScenario || isOnlyFooter}
                      style={{ marginLeft: "10px" }}
                      title={!hasLoadedAllJobs ? "Waiting for all subgroups to report models" : undefined}
                      type={"secondary"}
                      onClick={() => {
                        this.setState({ isCreatingScenario: true });
                        return saveScenario(scenarioName).then(() =>
                          this.setState({
                            isCreatingScenario: false,
                            scenarioName: userName ? userName + "'s Scenario" : "New Scenario"
                          })
                        );
                      }}
                    >
                      {isCreatingScenario ? (
                        <LoadingIndicator
                          style={{
                            width: "20px",
                            height: "18px",
                            transform: "scale(0.30)",
                            margin: "-5px 5px 5px -5px"
                          }}
                        />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  )}
                  {allScenarios && allScenarios.length > 1 && !isConsumer && (
                    <Button
                      onClick={() => {
                        this.setState({ isDeletingScenario: true });
                        return deleteScenario().then(() =>
                          this.setState({
                            isDeletingScenario: false
                          })
                        );
                      }}
                      disabled={isCreatingScenario || isDeletingScenario}
                    >
                      {isDeletingScenario ? (
                        <LoadingIndicator
                          style={{
                            width: "20px",
                            height: "18px",
                            transform: "scale(0.30)",
                            margin: "-5px 5px 5px -5px"
                          }}
                        />
                      ) : (
                        <FontAwesomeIcon icon={faTrash} />
                      )}
                    </Button>
                  )}
                </ButtonGroup>
              </React.Fragment>
            )}
            {isRetraining ? (
              <div className={styles.retrainButton} style={{ marginLeft: "30px" }}>
                <LoadingIndicator style={{ margin: "0px" }} />
              </div>
            ) : hasSetupIgnoreChanged && !isOnlyFooter ? (
              <Button
                type="primary"
                onClick={() => {
                  retrainRun();
                }}
                style={{ marginLeft: "30px" }}
              >
                {"Retrain with New Inputs"}
              </Button>
            ) : (
              ""
            )}
            {isCompare !== true && !isConsumer && !isContinuous && allScenarios && allScenarios.length > 1 && (
              <div
                className={styles.rButton}
                //style={{ right: hasSameScenario ? "167px" : "20px" }}
              >
                <Button
                  onClick={() => {
                    !isCompare === true && viewAllScenarios();
                    this.setState({ isCompare: !isCompare });
                  }}
                  disabled={selectedScenario === undefined || allScenarios.length < 2}
                  active={isCompare}
                >
                  {isCompare ? "Back to Aible Business" : "Compare"}
                </Button>
              </div>
            )}
            {isCompare === true && !isContinuous && (
              <div className={styles.rButton}>
                <Button onClick={() => this.setState({ isCompare: false })}>{"Back"}</Button>
              </div>
            )}
            {isCompare !== true && isForecast !== true && (
              <Button
                type={"primary"}
                disabled={
                  isDeployingProject ||
                  (optimized && optimized.isCreating) ||
                  isSelectedApproved ||
                  hasSameScenario !== true
                }
                onClick={() => {
                  this.setState({ isDeployingProject: true });
                  return deploy().then(() => this.setState({ isDeployingProject: false }));
                }}
                style={{ position: "absolute", right: "20px" }}
              >
                {isDeployingProject ? (
                  <LoadingIndicator
                    style={{
                      width: "20px",
                      height: "18px",
                      transform: "scale(0.30)",
                      margin: "-5px 5px 5px -5px"
                    }}
                  />
                ) : isSelectedApproved ? (
                  "Strategy Deployed"
                ) : (
                  "Deploy Strategy"
                )}
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }

  getIsHideFooter() {
    const { currentStep } = this.props;
    return (
      currentStep === UNIFIED_PROJECT_STEPS.INTEGRATE.id ||
      currentStep === UNIFIED_PROJECT_STEPS.MONITOR.id ||
      currentStep === UNIFIED_PROJECT_STEPS.FORECAST.id
    );
  }

  render() {
    const {
      id,
      isOnlyFooter,
      isAudit,
      isContinuous,
      isLoadingCompare,
      hasSplits,
      currentStep,
      optimized,
      isProjectNotFound
    } = this.props;
    const { isCompare, highlightStep } = this.state;

    const hideFooter = this.getIsHideFooter();

    if (isOnlyFooter) {
      return this.renderFooter();
    }

    if (isProjectNotFound) {
      return (
        <div className={styles.uProjectWrapper}>
          <ModelError errors={[{ code: "ProjectNotFound" }]} />
        </div>
      );
    }

    const showTabs = hasSplits && (currentStep !== UNIFIED_PROJECT_STEPS.BUSINESS_OPTIMIZATION.id || isContinuous);

    if (id !== "new" && optimized === undefined) {
      return (
        <div className={styles.uProjectWrapper}>
          <div className={styles.loading}>
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "-20%",
                marginBottom: "50px",
                transform: "scale(1.75)"
              }}
            />
            <div className={styles.loadMsg}>{"Loading project..."}</div>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.uProjectWrapper}>
        <BusinessHeaderContainer {...this.props} highlightStep={highlightStep} />
        <div
          className={
            styles.uProject +
            " " +
            (showTabs ? (this.state.showSubgroups ? styles.largeLeftPadding : styles.leftPadding) : "") +
            " " +
            (hideFooter ? styles.hideFooter : "")
          }
        >
          {showTabs ? (
            <SubgroupMenuContainer
              id={id}
              show={this.state.showSubgroups}
              updateShow={(v) => this.setState({ showSubgroups: v })}
            />
          ) : (
            ""
          )}
          {isCompare ? (
            isLoadingCompare ? (
              <LoadingIndicator />
            ) : (
              <CompareScenario {...this.props} onClose={() => this.setState({ isCompare: false })} />
            )
          ) : (
            <div className={styles.uProjectContent}>{this.renderStep()}</div>
          )}
        </div>
        {hideFooter ? <React.Fragment /> : this.renderFooter()}
      </div>
    );
  }
}
